import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Link } from '@mui/material';

import { useDisclosure } from '@/hooks/useDisclosure';

import { FeedArticleDialog } from './FeedArticleDialog';

export const FeedArticleDialogLink = ({
  CTAValue,
  CTALabel
}: {
  CTAValue: string;
  CTALabel?: string;
}) => {
  const { isOpen, open, close } = useDisclosure();
  const [groupName, fileName] = CTAValue.split('/');

  return (
    <>
      <Link
        color='gx.highlight'
        component='button'
        data-ph-capture-attribute-component-type='feed-article'
        data-ph-capture-attribute-file-name={fileName}
        data-ph-capture-attribute-group-name={groupName}
        sx={{
          textDecoration: 'none',
          verticalAlign: 'baseline',
          display: 'inline-flex',
          alignItems: 'center'
        }}
        onClick={open}
      >
        {CTALabel ?? 'See the article'}
        <ChevronRightIcon sx={{ fontSize: '1em' }} />
      </Link>
      <FeedArticleDialog
        CTAValue={CTAValue}
        open={isOpen}
        onClose={close}
      />
    </>
  );
};
